import React from "react";
import Context from "../../storage/context";
import { useContext } from "react";
import HeartButton from "../HeartButton/HeartButton";

const css = `
.car-share-btn {
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.15);
    border-radius: 8px;
    padding: 6px 10px;
    cursor: pointer;
    font-size: 16px;
    transition: 0.2s;
}

.car-share-btn:hover {
    background: rgba(255,255,255,0.15);
}`

const CardCar = ({ data, onDetails }) => {
    let ctx = useContext(Context);
    let like = false;

    function formatNumber(numStr) {
        return Number(numStr).toLocaleString("en-US");
    }

    const handleShare = (e) => {
        e.stopPropagation();
        const url = `${window.location.origin}/cars/${data.car_id}`;

        if (navigator.share) {

            navigator.share({
                title: `${data.car_make} ${data.car_full_type}`,
                text: `${data.car_make} ${data.car_full_type} ${data.year} - ${formatNumber(data.price)} ₪`,
                url
            });
        } else {
            navigator.clipboard.writeText(url);
        }
    };

    localStorage.getItem("like")



    return (
        <>
            <style>{css}</style>

            <div className="car-card" key={data.car_id} onClick={() => onDetails(data)} id={data.car_id}>
                <div className="car-img">
                    <div className="car-img-bg" style={{ background: `radial-gradient(ellipse at 50% 100%, ${data.color}, #05090f)` }}>
                        <HeartButton id={data.car_id} />
                        {data.tag !== "" && <span className="car-badge">{data.tag}</span>}
                        <img src={`${ctx.api_url}${data[data.who_is_p]}`} alt="car" loading="lazy" />
                        {data.isSale === "yes" && <div className="sold-ribbon">נמכר</div>}
                    </div>


                </div>
                <div className="car-body">
                    <div className="car-name">{data.car_make + " " + data.car_full_type}</div>
                    <div className="car-meta">
                        <span className="car-year">{data.year}</span>
                        <span className="car-year">{formatNumber(data.km)} ק״מ</span>
                        <span className="car-year">יד {data.hand} </span>
                        <span className="car-year">{formatNumber(data.engine)} סמ"ק  </span>
                    </div>
                    <div className="car-divider" />
                    <div className="car-price-row">
                        <div>
                            <div className="car-price">{formatNumber(data.price)} ₪</div>
                            <div className="car-price-label">כולל מע״מ</div>
                        </div>
                        <div style={{ display: "flex", gap: 8 }}>
                            <button className="car-share-btn" onClick={handleShare}>🔗</button>
                            <button className="car-cta-btn">לפרטים</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CardCar;